import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { HelpTooltip, Select, Stack } from '../../../primitives/index.js';
const GENDER_LIST = {
  MALE: {
    value: 'male',
    isDisabled: false
  },
  FEMALE: {
    value: 'female',
    isDisabled: false
  },
  VARIOUS: {
    value: 'various',
    isDisabled: true
  },
  WITHOUT: {
    value: 'without',
    isDisabled: true
  }
};
export const GenderSelect = restProps => {
  const {
    t
  } = useTranslation('authentication');
  const options = useMemo(() => Object.values(GENDER_LIST).map(({
    value,
    isDisabled
  }) => ({
    label: t(`genderSelect.options.${value}`),
    value,
    isDisabled
  })), [t]);
  return _jsxs(Stack, {
    direction: "row",
    alignItems: "center",
    children: [_jsx(Select, {
      options: options,
      pinnedPlaceholder: true,
      ...restProps,
      fullWidth: true
    }), _jsx(HelpTooltip, {
      content: t('genderSelect.tooltipContent')
    })]
  });
};